import React, { useEffect, useRef } from "react";
import axios from "axios";
import { automatedBrowserReason, solveCaptchaAsync } from "../../utils/registrationCaptcha";

export function CheckTick() {
  return (
    <svg className="browser-check__tick" viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="11" />
      <path d="M7 12.5l3.2 3.2L17.5 8.5" />
    </svg>
  );
}

function BrowserCheck({ onToken }) {
  const [state, setState] = React.useState("checking");
  const onTokenRef = useRef(onToken);
  onTokenRef.current = onToken;

  useEffect(() => {
    if (automatedBrowserReason()) {
      setState("blocked");
      onTokenRef.current("");
      return undefined;
    }

    let cancelled = false;

    (async () => {
      try {
        const { data } = await axios.get("/api/v1/auth/captcha");
        const nonce = await solveCaptchaAsync(data.challenge, data.difficulty);
        if (cancelled) return;
        onTokenRef.current(`${data.challenge}.${data.expires}.${data.difficulty}.${nonce}.${data.mac}`);
        setState("ok");
      } catch {
        if (!cancelled) {
          setState("error");
          onTokenRef.current("");
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  const label = {
    checking: "Checking this browser…",
    ok: "Browser check complete",
    blocked: "Automated browsers are blocked. Use a normal browser.",
    error: "Browser check failed. Refresh the page and try again.",
  }[state];

  return (
    <div className={`browser-check browser-check--${state}`} role="status">
      <span className="browser-check__mark" aria-hidden="true">
        {state === "ok" ? (
          <CheckTick />
        ) : (
          <span className={state === "checking" ? "browser-check__spinner" : "browser-check__cross"} />
        )}
      </span>
      <span>{label}</span>
    </div>
  );
}

export default BrowserCheck;
